module.exports = __webpack_public_path__ + "media/images/icons/calendar-check-322626932b3a5f0f7b7e4735ef529cc3.svg";